export default "__VITE_ASSET__BWH7pqlM__"